import Navbar from "../components/navbar"
import Footer from "../components/footer"
import front_model from '../images/front-model.jpg'
import LoadingOverlay from "../components/loading"
import emptyList from "../components/empty_list"
import { useCallback, useEffect, useState } from "react"
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCart } from "../hooks/add_to_cart"
import { FaTimes } from "react-icons/fa";
import {LiaTimesSolid} from "react-icons/lia";
import { ProductDetails } from "../components/product_details"
import { useCookies } from "react-cookie"
import { useNavigate, useParams } from "react-router-dom"
import { BarLoader } from "react-spinners"
import { PayPalButtons } from "@paypal/react-paypal-js";
import { IoMdCheckmarkCircleOutline } from "react-icons/io"
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import useEmblaCarousel from "embla-carousel-react";

export default function AboutUs({ route }) {
    const [pageLoading, setPageLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [featured_prod, setFeaturedProd] = useState([]);
    const [products, setProducts] = useState([]);
    const { addToCart, checkItemInCart, removeItem, convertAmount } = useCart();
    const [showModal, setShowModal] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const [cookies, removeCookie] = useCookies();
    const navigate = useNavigate();
    const [payment, setPayment] = useState("cod");
    const [pageData, setPageData] = useState({});
    const {reference} = useParams();

    const [emblaRef, emblaApi] = useEmblaCarousel();

    const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
    }, [emblaApi]);

    // Function to scroll to the next slide
    const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
    }, [emblaApi]);

    const services = [
    {
      name: "Customized Wigs",
      image: "/images/service1.avif",
      desc: "Experience the perfect blend of style and comfort with our customized wigs, tailored to match your unique preferences and personality. Every wig is expertly crafted to provide a natural look and flawless fit."
    },
    {
      name: "Sales of Hair Bundles",
      image: "/images/service2.avif",
      desc: "Explore our premium selection of hair bundles, designed for versatility and durability. From straight to curly textures, we offer bundles that enhance your look while maintaining softness and shine."
    },
    {
      name: "Wigs Laundry",
      image: "/images/service3.avif",
      desc: "Revive your wigs with our professional wig laundry service. We gently clean and restore your wigs to their original luster, extending their lifespan and maintaining their quality."
    },
    {
      name: "Seamed Wigs",
      image: "/images/service4.avif",
      desc: "Our seamed wigs are crafted with precision, ensuring a seamless and realistic finish. They provide a comfortable fit and natural appearance, perfect for any occasion."
    },
    {
      name: "Hair Accessories",
      image: "/images/service5.avif",
      desc: "Complete your look with our stylish range of hair accessories. From clips to headbands, we offer elegant options to enhance your hair's beauty effortlessly."
    },
    {
      name: "Hair Bleaching & training",
      image: "/images/service6.avif",
      desc: "Learn the art of hair transformation with our hair bleaching services and expert training sessions. We use safe techniques to achieve stunning results while providing hands-on guidance for hair enthusiasts and professionals."
    }
  ];

    return(
        <div className="w-full h-auto">
            {pageLoading && <LoadingOverlay />}
            <Navbar />
            <div className="pb-5 flex flex-col gap-2 font-outfit">
                <div className="embla" ref={emblaRef}>
                    <div className="embla__container">
                    {services.map((service, index) => (
                        <div key={index} className="grid lg:grid-cols-5 gap-2 embla__slide">
                        <div className="lg:col-span-2 lg:h-96">
                            <img
                            src={service.image}
                            alt={service.name}
                            className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="relative text-center lg:text-start lg:col-span-3 lg:h-96 bg-orange-500 text-white flex flex-col justify-center p-5 lg:p-10 gap-5 lg:gap-8">
                            <div className="flex flex-col gap-2">
                            <h2 className="text-3xl lg:text-4xl font-semibold">
                                {service.name}
                            </h2>
                            </div>
                            <p className="lg:text-lg font-light">{service.desc}</p>
                            <button className="mx-auto lg:mx-0 w-fit cursor-pointer hover:bg-white duration-300 hover:text-black  border px-5 py-2 rounded-full font-medium">
                            Learn More
                            </button>
                            <div className="absolute bottom-5 right-5 flex gap-2">
                            <button
                                onClick={scrollPrev}
                                className="bg-white p-5 cursor-pointer hover:text-white text-black hover:bg-inherit hover:border duration-300 size-8 place-content-center rounded-full"
                            >
                                <FaAngleLeft className="mx-auto size-4" />
                            </button>
                            <button
                                onClick={scrollNext}
                                className="bg-white p-5 cursor-pointer hover:text-white text-black hover:bg-inherit hover:border duration-300 size-8 place-content-center rounded-full"
                            >
                                <FaAngleRight className="mx-auto size-4" />
                            </button>
                            </div>
                        </div>
                        </div>
                    ))}
                    </div>
                </div>
                <div className="grid grid-cols-6 gap-2 [&>*]:h-full">
                    <img
                    className="lg:max-w-full aspect-square object-cover"
                    src="/images/pic4.avif"
                    alt="pic4"
                    />
                    <img
                    className="lg:max-w-full col-span-2 aspect-video object-cover"
                    src="/images/pic1.avif"
                    alt="pic1"
                    />
                    <img
                    className="lg:max-w-full aspect-square object-cover"
                    src="/images/pic3.avif"
                    alt="pic3"
                    />
                    <img
                    className="lg:max-w-full col-span-2 aspect-video object-cover"
                    src="/images/pic2.avif"
                    alt="pic2"
                    />
                </div>
                <div className="mx-auto w-11/12  space-y-4 md:space-y-2 py-10">
                    <h3 className="text-4xl leading-snug lg:text-6xl lg:leading-tight md:w-4/5 lg:w-3/5 font-outfit">
                        What makes
                        <span className="text-orange-500 font-medium"> Intimated By Itee</span> the
                        <span className="text-orange-500 font-medium"> better</span> option?
                    </h3>
                    <div className="flex justify-end">
                        <div className="lg:w-3/5 md:w-4/5 flex flex-col gap-2">
                        <p className="lg:text-lg font-light font-outfit">
                            At Intimated By Itee, we deliver exceptional service with guaranteed
                            accuracy—what you order is exactly what you get. From customized
                            wigs to expert wig laundry, our quality and care set us apart, all
                            backed by fast shipping and customer satisfaction at every step.
                        </p>
                        </div>
                    </div>
                </div>
                
            </div>
            <Footer />
        </div>
    )
}
